<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="partInspIimingText"
    item-value="partInspTimingCd"
    :label="label"
    :disabled="disabled"
    :loading="loading"
    :required="required"
    @change="onChange"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'PartInspTimingInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0115')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
  },

  methods: {
    onChange(e) {
      this.$emit('change', e)
    },
    async setPartInspTiming() {
      this.loading = true
      this.items = []

      try {
        let params = {}
        if (this.validOnly) {
          params.validOnly = true
        }

        const elements = await API.get('/master/partInspTimings', params)
        elements.forEach((element) => {
          element['partInspIimingText'] = `${element['partInspTimingCd']} : ${element['partInspTimingName']}`
          this.items.push(element)
        })
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0115') })))
      } finally {
        this.loading = false
      }
    },
  },

  async mounted() {
    await this.setPartInspTiming()
  },
}
</script>
